import React from 'react';
import { FiX } from 'react-icons/fi';

/**
 * Mobile menu component that slides in from the side
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the menu is open
 * @param {Function} props.onClose - Function to call when closing the menu
 * @param {React.ReactNode} props.children - Menu content
 * @param {string} [props.position='right'] - Menu position (left, right)
 */
const MobileMenu = ({ 
  isOpen, 
  onClose, 
  children,
  position = 'right',
  ...props 
}) => {
  if (!isOpen) return null;
  
  // Position classes
  const positionClasses = {
    left: 'inset-y-0 left-0 transform -translate-x-full',
    right: 'inset-y-0 right-0 transform translate-x-full'
  };
  
  // Animation classes based on position and open state
  const animationClasses = isOpen 
    ? 'transition-transform ease-out duration-300 transform translate-x-0' 
    : `transition-transform ease-in duration-300 ${positionClasses[position]}`;
  
  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        onClick={onClose}
        aria-hidden="true"
      />
      
      {/* Menu panel */}
      <div className={`fixed ${position === 'left' ? 'left-0' : 'right-0'} inset-y-0 max-w-xs w-full bg-white shadow-xl ${animationClasses}`}>
        <div className="h-full flex flex-col overflow-y-auto">
          {/* Close button */}
          <div className="px-4 pt-5 pb-2 flex items-center justify-between">
            <button
              className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500"
              onClick={onClose}
            >
              <span className="sr-only">Close menu</span>
              <FiX className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          
          {/* Menu content */}
          <div className="flex-1 px-4 py-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;